"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const create = (client, storeOptions) => {
    const toKey = (key) => storeOptions.namespace != null ? `${storeOptions.namespace}-${key}` : key;
    const get = (key) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        return new Promise((res, rej) => {
            client.get(key, (err, cb) => {
                if (err)
                    return rej(err);
                if (cb) {
                    res(JSON.parse(cb));
                }
                else {
                    res(null);
                }
            });
        });
    });
    const set = (key, value, options) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        return new Promise((res, rej) => {
            var _a;
            client.set(key, JSON.stringify(value), 'PX', (_a = options === null || options === void 0 ? void 0 : options.expireTime) !== null && _a !== void 0 ? _a : storeOptions.defaultExpireTime, (err) => {
                if (err)
                    return rej(err);
                res(undefined);
            });
        });
    });
    const setAdd = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        return new Promise((res, rej) => {
            client.sadd(key, JSON.stringify(value), (err) => {
                if (err)
                    return rej(err);
                res(undefined);
            });
        });
    });
    const setRemove = (key, value) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        return new Promise((res, rej) => {
            client.srem(key, JSON.stringify(value), (err) => {
                if (err)
                    return rej(err);
                res(undefined);
            });
        });
    });
    const del = (key) => {
        key = toKey(key);
        return new Promise((res, rej) => {
            client.del(key, (err) => {
                if (err)
                    return rej(err);
                res(undefined);
            });
        });
    };
    const getAndSetIfNotExists = (key, value, options) => __awaiter(void 0, void 0, void 0, function* () {
        key = toKey(key);
        return new Promise((res, rej) => {
            var _a;
            client
                .multi()
                .get(key)
                .set(key, JSON.stringify(value), 'NX', 'PX', (_a = options === null || options === void 0 ? void 0 : options.expireTime) !== null && _a !== void 0 ? _a : storeOptions.defaultExpireTime)
                .exec((err, reply) => {
                if (err)
                    return rej(err);
                const cb = reply[0];
                if (cb) {
                    res(JSON.parse(cb));
                }
                else {
                    res(null);
                }
            });
        });
    });
    const flush = () => {
        return new Promise((res, rej) => {
            var _a;
            client.keys(`${(_a = storeOptions.namespace) !== null && _a !== void 0 ? _a : ''}*`, (err, keys) => {
                if (err) {
                    return rej(err);
                }
                if (keys.length === 0) {
                    return res();
                }
                client.del(keys, (err) => {
                    if (err) {
                        return rej(err);
                    }
                    res();
                });
            });
        });
    };
    const backend = {
        get,
        set,
        setAdd,
        setRemove,
        del,
        getAndSetIfNotExists,
        flush,
    };
    return backend;
};
exports.create = create;
//# sourceMappingURL=redis.js.map